@for (row of rows; track row; let rowIndex = $index) {
  <tr role="row">
    @for (item of row; track item; let colIndex = $index) {
      <td
        role="gridcell"
        class="zwi-reference-body-cell"
        [tabIndex]="_isActiveCell(rowIndex, colIndex) ? 0 : -1"
        [class.zwi-reference-body-disabled]="!item.enabled || null"
        [class.zwi-reference-body-active]="_isActiveCell(rowIndex, colIndex)"
        [class.zwi-reference-body-range]="_isCellInRange(item.value)"
        [class.zwi-reference-body-cell-selected-solo]="_isSoloCell(item.value)"
        [class.zwi-reference-body-cell-selected-start]="_isStartCell(item.value)"
        [class.zwi-reference-body-cell-selected-end]="_selectedCell(item.value) === 'end'"
        (click)="_cellClicked(item)"
        (mouseover)="_onHover(item.value)"
        [style.width.%]="100 / numCols"
        [style.paddingTop.%]="50 * cellAspectRatio / numCols"
        [style.paddingBottom.%]="50 * cellAspectRatio / numCols">
        <div class="zwi-reference-body-cell-content"
          [class.zwi-reference-body-selected]="_selectedCell(item.value)">
          <!--         [class.zwi-reference-body-today]="todayValue === item.value">-->
          {{ item.displayValue }}
        </div>
      </td>
    }
    @if (rowIndex === 0 && _firstRowOffset) {
      <td
        aria-hidden="true"
        class="zwi-reference-body-label"
        [attr.colspan]="_firstRowOffset"
        [style.paddingTop.%]="50 * cellAspectRatio / numCols"
        [style.paddingBottom.%]="50 * cellAspectRatio / numCols">
        {{ '' }}
      </td>
    }
  </tr>
}
